import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("melletic_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const CREDIT_CODES = ["credits_exhausted", "daily_cap", "kill_switch", "feature_disabled", "budget", "conflict", "ai_limit"];

client.interceptors.response.use(
  (res) => {
    // Any successful AI-consuming call may have changed the balance.
    if (typeof window !== "undefined" && res.config?.method === "post") {
      window.dispatchEvent(new CustomEvent("mel:credits-refresh"));
    }
    return res;
  },
  (error) => {
    const detail = error.response?.data?.detail;
    if (error.response?.status === 402) {
      // Credit-related blocks carry a structured detail object with a code.
      if (detail && typeof detail === "object" && CREDIT_CODES.includes(detail.code)) {
        if (typeof window !== "undefined") {
          window.dispatchEvent(new CustomEvent("mel:credits-refresh"));
          window.dispatchEvent(new CustomEvent("mel:credits-blocked", { detail }));
        }
      } else {
        const msg = formatApiError(detail) || "This is a Premium feature.";
        if (typeof window !== "undefined") {
          window.dispatchEvent(new CustomEvent("mel:paywall", { detail: msg }));
        }
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : (typeof e === "string" ? e : ""))).filter(Boolean).join(" ") || "Something went wrong. Please try again.";
  if (typeof detail === "object") {
    if (typeof detail.error === "string") return detail.error;
    if (typeof detail.msg === "string") return detail.msg;
    if (typeof detail.detail === "string") return detail.detail;
    if (typeof detail.message === "string") return detail.message;
  }
  return "Something went wrong. Please try again.";
}

let currentAudio = null;
export async function playTTS(text, speed = 1.0) {
  const mod = await import("@/lib/audio");
  return mod.playTTS(text, speed);
}

export default client;
